import React, { Component } from "react";
import PropTypes from "prop-types";
import IssueListItem from "./IssueListItem";
import { CustomerShape } from "../../../../common/proptypes";

import * as firebase from "firebase";

class IssueList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listenerRef: null
    };

    this.loadIssueList = this.loadIssueList.bind(this);
    this.clearIssueList = this.clearIssueList.bind(this);
  }

  componentWillMount() {
    const { customer } = this.props;
    this.loadIssueList(customer.key);
  }

  componentWillReceiveProps(nextProps) {
    if (
      (!this.props.customer && nextProps.customer) ||
      this.props.customer.key !== nextProps.customer.key
    ) {
      this.clearIssueList();
      this.loadIssueList(nextProps.customer.key);
    }

    if (nextProps.issues) {
      this.props.onUpdateUI();
    }
  }

  loadIssueList(customerKey) {
    const { onDataReceived } = this.props;
    const path = `issues/${customerKey}`;
    const listenerRef = firebase.database().ref(path);
    listenerRef.on("value", snapshot => onDataReceived(path, snapshot.val()));

    this.setState({
      listenerRef
    });
  }

  clearIssueList() {
    if (this.state.listenerRef) {
      this.state.listenerRef.off();
    }
  }

  render() {
    const { className, customer } = this.props;
    const issues = this.props.issues
      ? Object.keys(this.props.issues).map(key => ({
          ...this.props.issues[key],
          key
        }))
      : [];
    issues.sort((a, b) => b.updated - a.updated);

    return issues.length > 0
      ? <div className={className}>
          <div className="md-grid">
            <h6
              className="md-cell md-cell--12 md-cell--bottom md-title profile-title"
              style={{ marginBottom: 10 }}
            >
              Issue List {issues && `(${issues.length})`}
            </h6>
            {issues.map(issue => (
              <IssueListItem
                key={issue.key}
                issue={issue}
                customerKey={customer.key}
              />
            ))}
          </div>
        </div>
      : null;
  }
}

IssueList.propTypes = {
  customer: CustomerShape,
  onUpdateUI: PropTypes.func.isRequired,
  onDataReceived: PropTypes.func.isRequired,
  className: PropTypes.string,
  /* eslint-disable react/forbid-prop-types */
  // Firebase key/value
  issues: PropTypes.object
  /* eslint-enable react/forbid-prop-types */
};

IssueList.defaultProps = {
  customer: {},
  className: null,
  issues: {}
};

export default IssueList;



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/IssueList/IssueList.jsx